import _extends from '@babel/runtime/helpers/extends';
import React__default, { useRef } from 'react';
import styled from 'styled-components';
import { useIsMobile, useTaktId, createStormTaktId, SearchInput, Flex } from '@amzn/storm-ui';
import { u as useIntl } from '../../LocalModules/storm-ui-intl/dist/esm/3rdPartyModules/react-intl/lib/src/components/useIntl-voJ4yxcS-DU7lWLPF.js';
import { u as useSearch } from '../../hooks/useSearch-D9iZPak2.js';

const FlexContainer = /*#__PURE__*/styled(Flex).withConfig({
  componentId: "sc-storm-ui-40027066__sc-1v59uw-0"
})(["border-bottom:", ";"], ({
  theme
}) => theme.border.subtle.default);
const CountrySelectorSearchInput = ({
  id,
  taktId,
  taktValue
}) => {
  const isMobile = useIsMobile();
  const {
    formatMessage
  } = useIntl();
  const searchInputRef = useRef(null);
  const {
    searchValue,
    setSearchValue
  } = useSearch();
  const {
    getDataTaktAttributes
  } = useTaktId({
    taktId,
    fallbackId: createStormTaktId('country-selector-search-input')
  });
  const handleSearch = event => {
    var _searchInputRef$curre;
    setSearchValue('value' in event.target ? event.target.value : '');
    (_searchInputRef$curre = searchInputRef.current) === null || _searchInputRef$curre === void 0 || _searchInputRef$curre.focus();
  };
  return /*#__PURE__*/React__default.createElement(FlexContainer, {
    justifyContent: "flex-start",
    paddingInlineStart: isMobile ? 'small' : 'base',
    paddingInlineEnd: isMobile ? 'small' : 'base',
    paddingBlockStart: "small",
    paddingBlockEnd: "small"
  }, /*#__PURE__*/React__default.createElement(SearchInput, _extends({}, getDataTaktAttributes({
    taktValue
  }), {
    id: `${id}-search-input`,
    placeholder: formatMessage({
      id: 'search-countries-placeholder'
    }),
    inputRef: searchInputRef,
    value: searchValue,
    onChange: handleSearch,
    onClear: handleSearch,
    clearButtonLabel: formatMessage({
      id: 'search-clear-button-label'
    }),
    fullWidth: true
  })));
};

export { CountrySelectorSearchInput as C };
//# sourceMappingURL=CountrySelectorSearchInput-DG7v7F4U.js.map
